import { useState, useContext } from "react";
import {
  Box,
  Grid,
  Stack,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
//Srcs
import { AuthContext } from "../../Context/AuthContext";
import "../../Style/pagestyle.scss";

import { useNavigate } from "react-router-dom";
import { ButtonCreate } from "../../Utils/Component";
import { useGetDistrictByProvice } from "../../Hooks/useGetDistrictByProvice";
import { useGetCapitalProvinceById } from "../../Hooks/useGetCapitalProvinceById";

import DistrictForm from "../../Components/District/DistrictForm";
import useWithDimension from "../../Hooks/useWithDimension";
import AccordionsDistrict from "./AccordionsDistrict";

export default function District() {
  const { t, language } = useContext(AuthContext);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const provinceId = queryParams.get("provinceId");

  const { refetch, tableData } = useGetDistrictByProvice({
    capicalProvincesId: provinceId,
  });

  const { data } = useGetCapitalProvinceById({
    id: provinceId,
  });

  // ======================= Resize width Screen ======================
  const { width } = useWithDimension();
  return (
    <div className="page-container">
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box className="slash" />

        <Typography
          className={t("class-page-title")}
          onClick={() => navigate("/setting")}
        >
          {t("page_setting")}
        </Typography>

        <Typography className={"slash-title"}>/</Typography>

        <Typography
          className={t("class-page-title")}
          onClick={() => navigate("/setting/capital-province")}
        >
          {t("page_province")}
        </Typography>

        <Typography className={"slash-title"}>/</Typography>

        <Typography className={t("class-page-title")}>
          {language === "en"
            ? data?.capital_province_name_en || ""
            : data?.capital_province_name_kh || ""}
        </Typography>
      </Stack>

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />

            {open && (
              <DistrictForm
                open={open}
                handleClose={handleClose}
                setRefetch={refetch}
                dialogTitle="Create"
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width="4%"
                >
                  {t("no")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="18%">
                  {t("thead_code")}
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="18%">
                  {t("thead_name")}(KH)
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="18%">
                  {t("thead_name")}(ENG)
                </TableCell>
                <TableCell className={t("class-name-header-title")} width="18%">
                  {t("thead_type")}
                </TableCell>

                <TableCell className={t("class-name-header-title")} width="8%">
                </TableCell>

                <TableCell
                  className={t("class-name-header-title-end")}
                  width="16%"
                ></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell colSpan={7} sx={{ padding: 0 }}>
                  <AccordionsDistrict
                    tableData={tableData}
                    setRefetch={refetch}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </div>
  );
}
